import { AxiosResponse } from 'axios'
import { acceptHMRUpdate, defineStore } from 'pinia'

import api from '@/lib/api'
import { transformInventoryLog } from '@/lib/utils/transformEntries'

import { ApiPagination, InventoryLog } from '@/types'

type State = {
  inventoryLogData: InventoryLog[]
  pagination: ApiPagination | Record<string, never>
}

type Actions = {
  getInventoryLog: (filters: {
    searchTerm: string
    currentPage: number
    pageSize: number
  }) => Promise<ApiPagination>
  downloadInventoryLog: (searchTerm: string) => Promise<AxiosResponse<BlobPart, unknown>>
  resetState: () => void
}

export const useInventoryLogStore = defineStore<string, State, Record<string, never>, Actions>(
  'inventory-log',
  {
    state: () => ({
      inventoryLogData: [],
      pagination: {},
    }),

    actions: {
      async getInventoryLog(filters) {
        const response = await api.inventoryTracking.getInventoryLogs(filters)
        const { inventoryLogs, pagination } = response.data
        const transformedLogs = inventoryLogs.map(transformInventoryLog)
        this.inventoryLogData = transformedLogs
        this.pagination = pagination
        return response.data.pagination
      },

      async downloadInventoryLog(searchTerm) {
        const response = await api.inventoryTracking.downloadInventoryLog(searchTerm)
        return response
      },

      resetState() {
        this.$reset()
      },
    },
  },
)

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useInventoryLogStore, import.meta.hot))
}
